import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProjectNotFound.css';

function ProjectNotFound() {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const handleViewExample = () => {
    // Force a full navigation to project 1
    navigate('/project/1', { replace: true });
    // Force a page reload to ensure fresh data
    window.location.reload();
  };

  const handleReturnHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="projectNotFoundContainer">
      <h1>Project Not Found</h1>
      <p>Project with ID "{projectId}" does not exist or has been removed.</p>
      <div className="actionButtons">
        <button onClick={handleReturnHome} className="homeLink">
          Return to Home
        </button>
        <button onClick={handleViewExample} className="viewExampleLink">
          View Example Project
        </button>
      </div>
    </div>
  );
}

export default ProjectNotFound; 